(function() {
    'use strict';
    angular
        .module('tmgApp')
        .controller('BonusObjMonthController', BonusObjMonthController);

    BonusObjMonthController.$inject = ['$state', '$uibModal', 'AlertService', 'Principal', 'pagingParams', 'BonusObjMonth', 'DateUtils'];

    function BonusObjMonthController($state, $uibModal, AlertService, Principal, pagingParams, BonusObjMonth, DateUtils) {
        var vm = this;

        vm.updateMonth = updateMonth;
        vm.titleCaseWord = titleCaseWord;
        vm.defineTdColor = defineTdColor;
        vm.defineSundayClass = defineSundayClass;
        vm.formatHours = formatHours;
        vm.defineValueClass = defineValueClass;
        vm.showDayPoints = showDayPoints;
        vm.formatHoursRatio = formatHoursRatio;
        vm.formatHoursDelta = formatHoursDelta;
        vm.defineHoursDeltaClass = defineHoursDeltaClass;
        vm.getValorisationTooltip = getValorisationTooltip;
        vm.selectedMonth = new Date(pagingParams.searchDate);
        vm.currentMonthLabel = formatPeriodLabel(vm.selectedMonth);
        vm.existingMonth = moment.months();
        vm.currentPeriodMonth = formatPeriodMonth(vm.selectedMonth);
        vm.dayOfWeekShort = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];
        vm.listTechniciens = [];
        vm.daysOfMonth = [];
        vm.showInterventions = false;
        vm.showVehicleHours = true;
        vm.isTechnicien = false;
        vm.selectedFilterTech = null;

        Principal.hasAuthority('ROLE_TECHNICIEN').then(function(result) {
            vm.isTechnicien = result;
            if (result) {
                vm.showVehicleHours = false;
            }
        });

        // Attend le jour de coupure de paie avant de construire les jours et lancer la requête.
        DateUtils.loadCutoffDay().then(function () {
            loadAllEventCalendar();
        });

        function updateMonth(arg) {
            if (arg === "prev") {
                vm.selectedMonth = previousMonth(vm.selectedMonth);
            }
            if (arg === "next") {
                vm.selectedMonth = nextMonth(vm.selectedMonth);
            }
            if (arg === "actual") {
                vm.selectedMonth = goToCurrent();
            }
            vm.currentMonthLabel = formatPeriodLabel(vm.selectedMonth);
            vm.currentPeriodMonth = formatPeriodMonth(vm.selectedMonth);
            pagingParams.searchDate = moment(vm.selectedMonth).format("YYYY-MM-DD");
            $state.transitionTo($state.$current, {
                searchDate: pagingParams.searchDate
            });
        }

        function loadAllEventCalendar() {
            buildDaysOfMonth();
            vm.currentMonthLabel = formatPeriodLabel(vm.selectedMonth);
            vm.currentPeriodMonth = formatPeriodMonth(vm.selectedMonth);

            BonusObjMonth.query({
                searchDate: pagingParams.searchDate
            }, onSuccess, onError);
        }

        function buildDaysOfMonth() {
            // Période de paie configurable (ex : 26 -> 25 du mois suivant).
            var startDate = DateUtils.getFirstDayOfPayrollPeriod(vm.selectedMonth);
            var endDate = DateUtils.getLastDayOfPayrollPeriod(vm.selectedMonth);
            var nbDays = Math.round((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;

            vm.daysOfMonth = [];
            for (var i = 0; i < nbDays; i++) {
                vm.daysOfMonth.push(moment(startDate).add(i, 'days'));
            }
        }

        function getValorisationTooltip(day) {
            if (!day || !day.valorisations || day.valorisations.length === 0) {
                return '';
            }
            return day.valorisations.map(function(valorisation) {
                var point = valorisation.point > 0 ? '+' + valorisation.point : valorisation.point;
                var commentary = valorisation.commentary ? valorisation.commentary : 'Aucun commentaire';

                return point + ' : ' + commentary;
            }).join(' | ');
        }

        function onSuccess(data) {
            vm.listTechniciens = Object.keys(data);
            vm.listTechniciens.splice(vm.listTechniciens.length - 2,2);
            vm.ApiResponseTab = Object.values(data);
            vm.ApiResponseTab.splice(vm.ApiResponseTab.length - 2,2);
            console.log(vm.ApiResponseTab)
        }

        function defineTdColor(day) {
            if (!day) {
                return "";
            }
            if (day.congeType != null) {
                switch (day.congeType) {
                    case "AT": return " tdPink";
                    case "CHP": return " tdGrey";
                    case "CP": return " tdBlue";
                    case "JR": return " tdGreen";
                    case "JD": return " tdOrange";
                    case "GD": return " tdPurple";
                    default: return "";
                }
            }
            var realisee = parseFloat(day.pointRealisee) || 0;
            var valorisation = parseFloat(day.pointObjectif) || 0;
            var objectif = parseFloat(day.objectif) || 0;
            if (realisee === 0 && valorisation === 0 && objectif === 0) {
                return "";
            }
            return (realisee + valorisation) >= objectif ? " day-objectif-ok" : " day-objectif-ko";
        }

        function defineValueClass(value) {
            if (value > 0) {
                return 'positive-value';
            }
            if (value < 0) {
                return 'negative-value';
            }
            return '';
        }

        function showDayPoints(day) {
            if (!day) {
                return false;
            }
            var realisee = parseFloat(day.pointRealisee) || 0;
            var objectif = parseFloat(day.objectif) || 0;
            var valorisation = parseFloat(day.pointObjectif) || 0;
            return realisee !== 0 || objectif !== 0 || valorisation !== 0;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function previousMonth(date) {
            return moment(date).subtract(1, 'month').toDate();
        }

        function nextMonth(date) {
            return moment(date).add(1, 'month').toDate();
        }

        function goToCurrent() {
            return new Date();
        }

        // Libellé de la période de paie courante (ex : "26/05/2026 - 25/06/2026").
        function formatPeriodLabel(date) {
            if (!date) {
                return '';
            }
            var start = DateUtils.getFirstDayOfPayrollPeriod(date);
            var end = DateUtils.getLastDayOfPayrollPeriod(date);
            return moment(start).format('DD/MM/YYYY') + ' - ' + moment(end).format('DD/MM/YYYY');
        }

        function formatPeriodMonth(date) {
            if (!date) {
                return '';
            }
            var end = DateUtils.getLastDayOfPayrollPeriod(date);
            return vm.existingMonth[end.getMonth()];
        }

        function titleCaseWord(word) {
            if (!word) return word;
            return word[0].toUpperCase() + word.substr(1).toLowerCase();
        }

        function defineSundayClass(date) {
            if (!date) {
                return "";
            }
            return moment(date).isoWeekday() === 7 ? " sunday-cell" : "";
        }

        function formatHours(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }
            var num = parseFloat(value);
            if (isNaN(num) || num <= 0) {
                return '';
            }
            var totalMinutes = Math.round(num * 60);
            var hours = Math.floor(totalMinutes / 60);
            var minutes = totalMinutes % 60;
            return hours + 'h' + (minutes < 10 ? '0' : '') + minutes;
        }

        function formatHoursValue(value) {
            var totalMinutes = Math.round((parseFloat(value) || 0) * 60);
            var hours = Math.floor(totalMinutes / 60);
            var minutes = totalMinutes % 60;
            return hours + 'h' + (minutes < 10 ? '0' : '') + minutes;
        }

        function formatHoursRatio(total, due) {
            var t = parseFloat(total) || 0;
            var d = parseFloat(due) || 0;
            if (t === 0 && d === 0) {
                return '';
            }
            return formatHoursValue(t) + ' / ' + formatHoursValue(d);
        }

        function formatHoursDelta(total, due) {
            var t = parseFloat(total) || 0;
            var d = parseFloat(due) || 0;
            if (t === 0 && d === 0) {
                return '';
            }
            var diff = t - d;
            var sign = diff > 0 ? '+' : (diff < 0 ? '-' : '');
            return sign + formatHoursValue(Math.abs(diff));
        }

        function defineHoursDeltaClass(total, due) {
            var t = parseFloat(total) || 0;
            var d = parseFloat(due) || 0;
            if (t === 0 && d === 0) {
                return '';
            }
            var diff = t - d;
            if (diff > 0) {
                return 'positive-value';
            }
            if (diff < 0) {
                return 'negative-value';
            }
            return '';
        }
    }
})();
